import { render, staticRenderFns } from "./search-dict.vue?vue&type=template&id=0e0c17c6&scoped=true"
import script from "./search-dict.vue?vue&type=script&lang=js"
export * from "./search-dict.vue?vue&type=script&lang=js"
import style0 from "./search-dict.vue?vue&type=style&index=0&id=0e0c17c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c17c6",
  null
  
)

export default component.exports